import { REPORT_TYPES } from '@repo/constants'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/reports/order-service')({
  staticData: {
    title: REPORT_TYPES.ORDER_SERVICE,
    crumb: REPORT_TYPES.ORDER_SERVICE,
    permissions: ['reports_view_order_service'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
